import { Input, Label, Select, Switch, Textarea } from '@ethsign/ui';
import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { Card, FormFieldCard } from '@/components';
import { ImageUpload } from '@/components/Upload';
import { queryTemplateCategories, queryTemplateCollections, queryTemplateProviders } from '@/services';

export const ReviewAndSave = ({ data, setData }: { data: any; setData: (v: any) => void }) => {
  const { data: categoryData } = useQuery({
    queryKey: ['categoryList'],
    queryFn: queryTemplateCategories
  });
  const { data: providerData } = useQuery({
    queryKey: ['providerList'],
    queryFn: queryTemplateProviders
  });

  const { data: collections } = useQuery({
    queryKey: ['collectionByCategory', data.categoryId],
    queryFn: () => queryTemplateCollections({ categoryId: data.categoryId }),
    enabled: !!data.categoryId && data.hasCollection
  });

  const onFileChange = async (url: string) => {
    console.log(url);
    setData({ coverPicture: url });
  };

  return (
    <div className="h-full overflow-y-auto">
      <Card title={'Template Settings'} className={'w-[800px] m-auto mt-6'}>
        <div className="py-6">
          <div className="flex gap-2 items-center px-6">
            <Label>This template is a version of a template collection</Label>
            <Switch checked={data.hasCollection} onCheckedChange={(v) => setData({ hasCollection: v })} />
          </div>
          <FormFieldCard
            title={'Template Category'}
            description={'Which category does this contract template fall in?'}
          >
            <Select
              placeholder={'Select Category'}
              options={
                categoryData?.rows?.map((it: any) => ({
                  label: it.categoryName,
                  value: it.id
                })) || []
              }
              value={data.categoryId}
              onChange={(v) => {
                setData({ categoryId: v });
              }}
            />
          </FormFieldCard>
          {data.hasCollection && (
            <FormFieldCard
              title={'Template Collection Name*'}
              description={'Contract name should not exceed 250 characters.'}
            >
              <Select
                placeholder={'Select Collection'}
                options={
                  collections?.rows?.map((it: any) => ({
                    label: it.collectionName,
                    value: it.id
                  })) || []
                }
                value={data.collectionId}
                onChange={(v) => setData({ collectionId: v })}
              />
            </FormFieldCard>
          )}
          <FormFieldCard
            title={'Template Provider'}
            description={'Which provider does this contract template fall in?'}
          >
            <Select
              placeholder={'Select Provider'}
              options={
                providerData?.rows?.map((it: any) => ({
                  label: it.providerName,
                  value: it.id
                })) || []
              }
              value={data.providerId}
              onChange={(v) => setData({ providerId: v })}
            />
          </FormFieldCard>
          <FormFieldCard title={'Template Name*'} description={'Contract name should not exceed 250 characters.'}>
            <Input
              type="text"
              placeholder={'Amazing Contract'}
              value={data.name}
              onChange={(e) => setData({ name: e.target.value })}
            />
          </FormFieldCard>
          <FormFieldCard
            title={'Applicable Jurisdiction'}
            description={'Which jurisdiction governs this contract template?'}
          >
            <Input
              type="text"
              placeholder={'United States/Non-US/Singapore'}
              value={data.applicableJurisdictions}
              onChange={(e) => setData({ applicableJurisdictions: e.target.value.slice(0, 500) })}
            />
          </FormFieldCard>
          <FormFieldCard title={'Template Description'} description={'Write a short description of this template.'}>
            <Textarea
              placeholder={'Template Description'}
              value={data.description}
              onChange={(e) => setData({ description: e.target.value.slice(0, 1500) })}
            />
          </FormFieldCard>
          <FormFieldCard title={'Cover Image:'}>
            <ImageUpload onChange={onFileChange} value={data.coverPicture} className="w-full border-none h-auto" />
          </FormFieldCard>
        </div>
      </Card>
    </div>
  );
};
